import React, { useState, useRef } from 'react'
import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert';
import FormLabel  from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import axios from 'axios';

const BillingForm = ({ 
  billingInfo,
  setBillingInfo,
  customerId, 
  connectedStripeId,
  setDisplayBillingForm,
  setSuccessMessage
}) => {

  const API_URL = 'https://1d6q9mtu49.execute-api.us-west-2.amazonaws.com';
  const states = [ "AK","AL","AR","AS","AZ","CA","CO","CT","DC","DE","FL","GA","GU","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","ND","NE","NH","NJ","NM","NV","NY","OH","OK","OR","PA","PR","RI","SC","SD","TN","TX","UT","VA","VI","VT","WA","WI","WV","WY"]
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // save an instance of the original billing state
  const billingInfoRef = useRef(billingInfo);
  
  // update the billing info object
  const onChange = ({ target }) => {
    const { name, value } = target;
    setBillingInfo({...billingInfo, [name]: value });
  }

  // update the stripe customer object with the new billing details
  const saveBillingInfo = async(e) => {
    e.preventDefault();

    setErrorMessage('');
    setIsLoading(true);

    const { error } = await axios.post(`${API_URL}/update-customer`,{
      customerId,
      connectedStripeId,
      billingInfo
    })

    if(error){
      return setErrorMessage(error);
    }

    setIsLoading(false);
    setSuccessMessage('Billing Info Successful Updated');
    // close billing form
    setDisplayBillingForm(false)
  }

  const closeForm = () => {
    // update the billingInfo back to the original state
    setBillingInfo(billingInfoRef.current)
    // close billing form
    setDisplayBillingForm(false);
  }

  return (
    <>
      {errorMessage && 
        <Alert variant="filled" severity="error">
          {errorMessage}
        </Alert>
      }
      
      
        <Grid item>
          <form onSubmit={saveBillingInfo}>

            <FormLabel>Address</FormLabel>
            <TextField
              fullWidth
              value={billingInfo.line1}  
              type='text'
              name="line1"
              onChange={onChange}
              variant="outlined" 
              required/>

            <FormLabel>Address 2</FormLabel>
            <TextField
              fullWidth
              type='text'
              name="line2"
              value={billingInfo.line2}
              placeholder='Apt 100'
              onChange={onChange}
              variant="outlined"/>

            <FormLabel>Town/City</FormLabel>
            <TextField
              fullWidth
              value={billingInfo.city}  
              type='text'
              name="city"
              onChange={onChange}
              variant="outlined" 
              required/>

            <FormLabel>State</FormLabel>
            <TextField
              fullWidth
              select
              name="state"
              value={billingInfo.state}  
              onChange={onChange}
              variant="outlined" 
              required	
            >
              {states.map((state, i) => <option key={i} value={state}>{state}</option>)}
            </TextField >

            <FormLabel>ZIP code</FormLabel>
            <TextField
              fullWidth
              value={billingInfo.postal_code}  
              type='tel'
              name="postal_code"
              onChange={onChange}
              variant="outlined"
              placeholder="5 Digit"
              inputProps={{
                pattern:"[0-9]{5}"
              }}
              required/>

            <Grid 
              container  
              direction="column" 
              alignItems="center"
              lg={12}
            >
             
              <Button 
                fullWidth
                type="submit"
                color="primary" 
                variant='contained'
                placeholder=""
                disabled={isLoading}
              >
                Save Address
              </Button>

              <Button 
                fullWidth
                margin="normal"
                onClick={closeForm} 
                color="primary" 
                variant='text'
                disabled={isLoading}
              >
                Cancel
              </Button>
            </Grid>
        
          </form>
        </Grid>
        <Grid item>
          {/* <Alert variant="outlined" severity="warning" margin="normal">
            Any updates to the address will also be reflected in your account. 
            Changes to the address may affect your monthly subscription charge 
            due to state sales tax.
          </Alert> */}
        </Grid>
    </>
  )
}

export default BillingForm